import { AlertTriangle, RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errorMessage } from "@/lib/error-message";

interface QueryErrorProps {
  error: unknown;
  onRetry: () => void;
  /** Sunucu mesajı yoksa gösterilecek metin */
  fallback?: string;
  className?: string;
}

/** Liste/sayfa verisi yüklenemediğinde boş durum yerine gösterilir. */
export function QueryError({
  error,
  onRetry,
  fallback = "Veriler yüklenemedi.",
  className,
}: QueryErrorProps) {
  return (
    <div
      role="alert"
      className={
        className ??
        "flex flex-col items-center justify-center gap-3 h-40 text-sm text-muted-foreground"
      }
    >
      <div className="flex items-center gap-2 text-destructive">
        <AlertTriangle className="h-4 w-4" />
        <span>{errorMessage(error, fallback)}</span>
      </div>
      <Button variant="outline" size="sm" onClick={onRetry}>
        <RotateCw className="h-4 w-4 mr-2" />
        Tekrar dene
      </Button>
    </div>
  );
}
